import { colors } from "../utils/constants";
import { Box } from "@mui/material";

interface Props {
  label?: string;
  dataInfo?: number;
  children?: React.ReactNode;
}

function CardInfo({ label, dataInfo, children }: Props) {
  return (
    <Box style={styles.cardContainer}>
      <span style={styles.dataInfo}>{dataInfo}</span>
      <span style={styles.label}>{label}</span>
      {children}
    </Box>
  );
}

const isMobile = window.innerWidth < 768;

const styles: any = {
  cardContainer: {
    width: "100%",
    minHeight: isMobile ? 110 : 100,
    backgroundColor: colors.white,
    border: "1.5px solid #E5E9F0",
    borderRadius: 16,
    boxShadow: "0 10px 24px -16px rgba(20,33,61,.16)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: 4,
  },
  dataInfo: {
    fontSize: isMobile ? 24 : 32,
    fontWeight: 800,
    color: colors.primary,
    lineHeight: 1,
  },
  label: {
    fontSize: isMobile ? 12 : 13,
    fontWeight: 600,
    color: "#5B6472",
  },
};

export default CardInfo;
